import React, { useEffect, useState } from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import TopTitleBanner from "../component/TopTitleBanner";
import "../css/dashboard.css";
import "../css/client.css";
import "../css/setting.css";
import { useAuth } from "../contexts/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import { toast } from "react-toastify";
import { roles } from "../firebase.collection";
import {
  deleteDoc,
  doc,
  documentId,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  where,
  collection,
} from "firebase/firestore";
import { db } from "../firebase";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import TitleMedium5Mobile from "../component/Titles/TitleMedium5Mobile";
import FormLineMedium5mobile from "../component/FormLineMedium5mobile";
import TopTitleFormComponentMobile from "../component/forms/TopTitleFormComponentMobile";
import RolesPermissionsOverview from "../component/RolesPermissionsOverview";

export default function RolesContentMobile() {
  const [allRoles, setAllRoles] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [whitelistEmail, setWhitelistEmail] = useState("");
  const [whitelistEntries, setWhitelistEntries] = useState([]);
  const [isWhitelistLoading, setIsWhitelistLoading] = useState(true);
  const [isWhitelistSaving, setIsWhitelistSaving] = useState(false);
  const [openWhitelistModal, setOpenWhitelistModal] = useState(false);
  const { currentUser } = useAuth();

  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 320,
    height: 360,
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
    overflow: "hidden",
  };

  // useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics(
  //       "Roles",
  //       "pageLoadMobile",
  //       currentUser.email,
  //       "read",
  //       "bodhi"
  //     );
  //   }
  // }, [currentUser.email]);

  const userIdState = currentUser ? currentUser.uid : "";

  useEffect(() => {
    const roleCollection = collection(db, "roles");
    const unsubscribe = onSnapshot(roleCollection, (querySnapshot) => {
      setAllRoles(
        querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      );
    });
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const listQuery = query(
      collection(db, "externalAccessWhitelist"),
      orderBy("emailLower")
    );
    const unsubscribe = onSnapshot(
      listQuery,
      (snapshot) => {
        const items = snapshot.docs.map((item) => ({
          id: item.id,
          ...item.data(),
        }));
        setWhitelistEntries(items);
        setIsWhitelistLoading(false);
      },
      (error) => {
        console.error(error);
        setIsWhitelistLoading(false);
      }
    );
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  const isSuperAdmin =
    userRole === "Super Admin" || userRole === "Clinical Director";

  const handleAddWhitelist = async () => {
    const email = whitelistEmail.trim().toLowerCase();
    if (!email) {
      toast.error("Email is required.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email.");
      return;
    }
    setIsWhitelistSaving(true);
    try {
      await setDoc(
        doc(db, "externalAccessWhitelist", email),
        {
          email,
          emailLower: email,
          enabled: true,
          updatedAt: serverTimestamp(),
          createdAt: serverTimestamp(),
        },
        { merge: true }
      );
      setWhitelistEmail("");
      setOpenWhitelistModal(false);
      toast.success("Whitelist updated.");
    } catch (error) {
      console.error(error);
      toast.error("Unable to update whitelist.");
    }
    setIsWhitelistSaving(false);
  };

  const handleCloseWhitelistModal = () => {
    setOpenWhitelistModal(false);
    setWhitelistEmail("");
  };

  const handleRemoveWhitelist = async (emailId) => {
    if (!window.confirm("Remove this email from the whitelist?")) return;
    try {
      await deleteDoc(doc(db, "externalAccessWhitelist", emailId));
      toast.success("Email removed.");
    } catch (error) {
      console.error(error);
      toast.error("Unable to remove email.");
    }
  };

  return (
    <div className="right-container-mobile">
      {/* ... existing code ... */}

      {isSuperAdmin ? (
        <div className="roles-management-shell">
          <Modal
            open={openWhitelistModal}
            onClose={handleCloseWhitelistModal}
            aria-labelledby="whitelist-modal-title"
            aria-describedby="whitelist-modal-description"
          >
            <Box sx={styleModalGeneral}>
              <div style={{ width: "auto", height: "100%" }}>
                <div className="line1-modal-percent">
                  <TopTitleFormComponentMobile
                    title="Whitelisted email"
                    closemodal={handleCloseWhitelistModal}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginTop: "3px",
                    height: "70%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingLeft: "14px",
                    paddingRight: "14px",
                    paddingBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "10px",
                      color: "#5a5a5a",
                      textAlign: "center",
                      fontSize: "12px",
                    }}
                  >
                    Add an email to grant Bodhi access to external users (outside
                    miraclesasia). Only @gmail.com addresses are allowed.
                  </div>
                  <TextField
                    label="Email"
                    value={whitelistEmail}
                    onChange={(e) => setWhitelistEmail(e.target.value)}
                    fullWidth
                    size="small"
                  />
                </div>
                <div
                  className="line4-modal-percent-bis"
                  style={{
                    height: "24%",
                    alignItems: "center",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingRight: 30,
                    boxSizing: "border-box",
                    transform: "translateY(-6px)",
                  }}
                >
                  <>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        fontSize: "12px",
                      }}
                      onClick={handleCloseWhitelistModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleAddWhitelist}
                      style={
                        isWhitelistSaving
                          ? {
                              backgroundColor: "red",
                              color: "white",
                              marginLeft: "12px",
                              fontSize: "12px",
                            }
                          : {
                              backgroundColor: "#1565C0",
                              color: "white",
                              marginLeft: "12px",
                              fontSize: "12px",
                            }
                      }
                      disabled={isWhitelistSaving}
                    >
                      {isWhitelistSaving ? "ADDING..." : "ADD"}
                    </Button>
                  </>
                </div>
              </div>
            </Box>
          </Modal>
          <TopTitleBannerMobile title={"Role management"} />

          <div className="roles-permissions-entry roles-permissions-entry-mobile">
            <RolesPermissionsOverview />
          </div>

          <div className="profile-title-setting roles-mobile-intro">
            <div className="roles-onboarding-panel">
              <div className="roles-onboarding-title">To add a user</div>
              <div className="roles-onboarding-steps">
                <div className="roles-onboarding-step">
                  <span className="roles-onboarding-index">1</span>
                  <div>
                    <div className="roles-onboarding-step-title">
                      Create G Suite email
                    </div>
                    <div className="roles-onboarding-step-text">
                      Create the staff email in Google Workspace.
                    </div>
                  </div>
                </div>
                <div className="roles-onboarding-step">
                  <span className="roles-onboarding-index">2</span>
                  <div>
                    <div className="roles-onboarding-step-title">
                      First Bodhi login
                    </div>
                    <div className="roles-onboarding-step-text">
                      The user logs in once and starts as Normal User.
                    </div>
                  </div>
                </div>
                <div className="roles-onboarding-step">
                  <span className="roles-onboarding-index">3</span>
                  <div>
                    <div className="roles-onboarding-step-title">
                      Assign role here
                    </div>
                    <div className="roles-onboarding-step-text">
                      Update their role from the user list below.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-role">
            <TitleMedium5Mobile />
            {allRoles.map((role) => (
              <FormLineMedium5mobile
                key={role.id}
                userId={role.id}
                userName={role.displayName}
                userRole={role.role}
                userPhone={role.phoneNumber}
                userEmail={role.userEmail}
              />
            ))}
          </div>

          <div
            style={{
              margin: "20px 16px",
              background: "#f4f6f8",
              borderRadius: "12px",
              padding: "12px 16px",
              border: "1px solid #e3e7ec",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
              }}
            >
              <div style={{ fontWeight: 600 }}>Whitelisted email</div>
              <button
                type="button"
                onClick={() => setOpenWhitelistModal(true)}
                style={{
                  border: "1px solid #1f5eff",
                  background: "white",
                  color: "#1f5eff",
                  padding: "6px 10px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                Add whitelisted email
              </button>
            </div>
            <div style={{ marginTop: "10px" }}>
              {isWhitelistLoading ? (
                <div>Loading whitelist...</div>
              ) : whitelistEntries.length === 0 ? (
                <div>No emails added.</div>
              ) : (
                <div>
                  {whitelistEntries.map((entry) => (
                    <div
                      key={entry.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                        padding: "6px 0",
                        borderBottom: "1px solid #e5e5e5",
                      }}
                    >
                      <div style={{ wordBreak: "break-all" }}>
                        {entry.email}
                      </div>
                      <button
                        type="button"
                        onClick={() => handleRemoveWhitelist(entry.id)}
                        style={{
                          border: "none",
                          background: "transparent",
                          color: "#cc0000",
                          cursor: "pointer",
                          fontSize: "12px",
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <TopTitleBanner title={"Role management"} />
          <p style={{ marginLeft: "60px", color: "red", fontWeight: "bold " }}>
            --You don't have Super-admin credentials to access this page--
          </p>
        </div>
      )}
    </div>
  );
}
